import React, { useState, useEffect } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { Button } from 'reactstrap';

const CustomDateRangeFilter = (props) => {
  const { selectedKeys, confirm, clearFilters } = props;
const [startDate, setStartDate] = useState(selectedKeys?.[0] || null);
const [endDate, setEndDate] = useState(selectedKeys?.[1] || null);

  const [showDatePicker, setShowDatePicker] = useState(true);

  const handleResetDateRange = () => {
    setStartDate(null);
    setEndDate(null);
  };

  const handleDatePickerToggle = () => {
    setShowDatePicker(!showDatePicker);
  };

  const handleDatePickerChange = (dates) => {
    setStartDate(dates[0]);
    setEndDate(dates[1]);
  };

  const handleApplyFilter = () => {
    confirm([startDate, endDate]);
    handleDatePickerToggle();
  };

  return (
    <div style={{ padding: 8 }}>
      
      {showDatePicker && (
        <DatePicker
          selected={startDate}
          onChange={handleDatePickerChange}
          startDate={startDate}
          endDate={endDate}
          selectsRange
          inline
        />
      )}
    
    
    </div>
  );
};

export default CustomDateRangeFilter;
